import { render, staticRenderFns } from "./BlogComments.vue?vue&type=template&id=39759c8a&scoped=true&"
import script from "./BlogComments.vue?vue&type=script&lang=js&"
export * from "./BlogComments.vue?vue&type=script&lang=js&"
import style0 from "./BlogComments.vue?vue&type=style&index=0&id=39759c8a&lang=scss&scoped=true&"
import style1 from "./BlogComments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39759c8a",
  null
  
)

export default component.exports